import React from "react";
import "./Group75.sass";

function Group75(props) {
  const { src, className } = props;

  return (
    <div className={`group-75 ${className || ""}`}>
      <img className="vector" src={src} />
    </div>
  );
}

export default Group75;
